export default {
  "primaryColor": "#3154ea",
  "lightColor": "#8aa7f7",
  "darkColor": "#24439f"
};